const LOGO_STORAGE_KEY = 'school_profile_logo_url'
const LOGO_EVENT_NAME = 'school_logo_changed'

let inMemoryLogoUrl: string | null = null

export function readSchoolLogo(): string | null {
  return inMemoryLogoUrl
}

export function writeSchoolLogo(url: string | null): void {
  inMemoryLogoUrl = url
  try {
    localStorage.removeItem(LOGO_STORAGE_KEY)
    sessionStorage.removeItem(LOGO_STORAGE_KEY)
    window.dispatchEvent(new CustomEvent(LOGO_EVENT_NAME, { detail: url }))
  } catch {
    // ignore
  }
}
